import { Controller } from "@hotwired/stimulus"

// One-shot overflow check for CSS line-clamp + Ver más / Ver menos.
// No ResizeObserver/MutationObserver — content is static or refreshed via Turbo.
// Clamp class names must stay in sync with ExpandableRichTextComponent::CLAMP_CLASSES.
const CLAMP_CLASSES = {
  2: "line-clamp-2",
  3: "line-clamp-3",
  4: "line-clamp-4",
  5: "line-clamp-5",
  6: "line-clamp-6"
}

export default class extends Controller {
  static targets = ["content", "more", "less"]

  static values = {
    lines: { type: Number, default: 4 }
  }

  connect () {
    this.expanded = false
    this.applyClamp()
    requestAnimationFrame(() => this.checkOverflow())
  }

  expand () {
    this.expanded = true
    this.removeClamp()
    this.moreTarget.classList.add("hidden")
    this.lessTarget.classList.remove("hidden")
  }

  collapse () {
    this.expanded = false
    this.applyClamp()
    this.lessTarget.classList.add("hidden")
    this.checkOverflow()
  }

  checkOverflow () {
    if (!this.hasContentTarget || !this.hasMoreTarget || this.expanded) return

    this.applyClamp()
    const overflowing = this.contentTarget.scrollHeight > this.contentTarget.clientHeight + 1
    this.moreTarget.classList.toggle("hidden", !overflowing)
    if (this.hasLessTarget) this.lessTarget.classList.add("hidden")
  }

  applyClamp () {
    this.contentTarget.classList.add(this.clampClass)
  }

  removeClamp () {
    this.contentTarget.classList.remove(this.clampClass)
  }

  get clampClass () {
    return CLAMP_CLASSES[this.linesValue] || "line-clamp-4"
  }
}
